import { render } from "./ProgSwitch.vue?vue&type=template&id=38a3a7ba&scoped=true"
import script from "./ProgSwitch.vue?vue&type=script&lang=js"
export * from "./ProgSwitch.vue?vue&type=script&lang=js"

import "./ProgSwitch.vue?vue&type=style&index=0&id=38a3a7ba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38a3a7ba"]])

export default __exports__